import React from 'react';
import { Link } from 'react-router-dom';
import { Gamepad2, Utensils, ArrowRight } from 'lucide-react';
import { upcomingProducts } from '../mock';

const ComingSoon = () => {
  const featured = upcomingProducts.filter((p) => p.image);

  return (
    <section className="px-5 md:px-8 py-16 md:py-24 bg-[#1a1a1a] text-[#FFF4E6]">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#E63946] text-[#FFF4E6] px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest">
              <Utensils size={14} /> Play Time
            </div>
            <h2 className="font-display text-5xl md:text-7xl uppercase leading-[0.9] mt-4">
              Snacks are<br />
              <span className="text-[#FFD84D]">coming soon.</span>
            </h2>
            <p className="mt-5 text-lg font-brico max-w-md opacity-80">
              The packs are designed, the crunch is being perfected. Meanwhile, play <span className="text-[#FFD84D] font-bold">Sky Catch</span>, our 30-second game, and top the leaderboard!
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/play" className="btn-chunky primary">
                <Gamepad2 size={18} /> Play the Game
              </Link>
              <Link to="/shop" className="btn-chunky outline">
                See the lineup <ArrowRight size={16} />
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 md:gap-4">
            {featured.map((p, i) => (
              <div
                key={p.id}
                className={`relative overflow-hidden rounded-2xl crunch-shadow bg-white ${i % 2 === 1 ? 'mt-6' : ''} ${i % 2 === 0 ? 'float' : 'wobble'}`}
              >
                <img src={p.image} alt={`${p.line} — ${p.flavor}`} className="w-full aspect-[4/5] object-cover" />
                <div className="absolute bottom-2 left-2 right-2 bg-[#1a1a1a]/90 text-[#FFF4E6] rounded-full px-2.5 py-1 text-[9px] font-bold uppercase tracking-widest text-center truncate">
                  {p.flavor} · Coming soon
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComingSoon;
